import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { RequireAuth } from './auth/RequireAuth';
import { AppShell } from './components/layout/AppShell';
import { DashboardPage } from './pages/Dashboard';
import { TermsPage } from './pages/Terms';
import { PrivacyPage } from './pages/Privacy';

const TriagePage = lazy(() => import('./pages/Triage').then(m => ({ default: m.TriagePage })));
const MergePage = lazy(() => import('./pages/Merge').then(m => ({ default: m.MergePage })));
const BackfillPage = lazy(() => import('./pages/Backfill').then(m => ({ default: m.BackfillPage })));
const LifecyclePage = lazy(() => import('./pages/Lifecycle').then(m => ({ default: m.LifecyclePage })));
const AuditPage = lazy(() => import('./pages/Audit').then(m => ({ default: m.AuditPage })));
const DealsPage = lazy(() => import('./pages/registers/Deals').then(m => ({ default: m.DealsPage })));
const DealDetailPage = lazy(() => import('./pages/registers/DealDetail').then(m => ({ default: m.DealDetailPage })));
const PipelineDashboardPage = lazy(() => import('./pages/registers/PipelineDashboard').then(m => ({ default: m.PipelineDashboardPage })));
const EntitiesPage = lazy(() => import('./pages/registers/Entities').then(m => ({ default: m.EntitiesPage })));
const SuppliersPage = lazy(() => import('./pages/registers/Suppliers').then(m => ({ default: m.SuppliersPage })));
const InvestorsPage = lazy(() => import('./pages/registers/Investors').then(m => ({ default: m.InvestorsPage })));
const FunctionsRegisterPage = lazy(() => import('./pages/registers/Functions').then(m => ({ default: m.FunctionsRegisterPage })));
const SourcesPage = lazy(() => import('./pages/admin/Sources').then(m => ({ default: m.SourcesPage })));
const ExclusionsPage = lazy(() => import('./pages/admin/Exclusions').then(m => ({ default: m.ExclusionsPage })));
const SkippedPage = lazy(() => import('./pages/admin/Skipped').then(m => ({ default: m.SkippedPage })));
const RebucketDealsPage = lazy(() => import('./pages/admin/RebucketDeals').then(m => ({ default: m.RebucketDealsPage })));

function PageFallback() {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="h-6 w-6 rounded-full border-2 border-divider border-t-petrol animate-spin" />
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/*" element={
        <RequireAuth>
          <AppShell>
            <Suspense fallback={<PageFallback />}>
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/triage" element={<TriagePage />} />
                <Route path="/merge" element={<MergePage />} />
                <Route path="/backfill" element={<BackfillPage />} />
                <Route path="/lifecycle" element={<LifecyclePage />} />
                <Route path="/registers/deals" element={<DealsPage />} />
                <Route path="/registers/deals/:dealId" element={<DealDetailPage />} />
                <Route path="/registers/pipeline" element={<PipelineDashboardPage />} />
                <Route path="/registers/entities" element={<EntitiesPage />} />
                <Route path="/registers/suppliers" element={<SuppliersPage />} />
                <Route path="/registers/investors" element={<InvestorsPage />} />
                <Route path="/registers/functions" element={<FunctionsRegisterPage />} />
                <Route path="/admin/sources" element={<RequireAuth adminOnly><SourcesPage /></RequireAuth>} />
                <Route path="/admin/exclusions" element={<RequireAuth adminOnly><ExclusionsPage /></RequireAuth>} />
                <Route path="/admin/skipped" element={<RequireAuth adminOnly><SkippedPage /></RequireAuth>} />
                <Route path="/admin/rebucket" element={<RequireAuth adminOnly><RebucketDealsPage /></RequireAuth>} />
                <Route path="/audit" element={<RequireAuth adminOnly><AuditPage /></RequireAuth>} />
              </Routes>
            </Suspense>
          </AppShell>
        </RequireAuth>
      } />
    </Routes>
  );
}
